import axios from "@/axios.js"

export default {
  fetchClubClasses({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewAllClubCalender")
        .then((response) => {
          response.data.forEach(function(entry) {
            var labelColor =  "event-success"
            if (entry.class_type == "teori") labelColor = "event-success"
            else if (entry.class_type == "manøvre") labelColor = "event-warning"
            else if (entry.class_type == "glatbane") labelColor = "event-danger"
            else labelColor = "event-primary"

            entry.startDate = new Date(entry.date+" "+entry.time_from)
            entry.endDate = new Date(entry.date+" "+entry.time_to)

            entry.title = entry.module.name+" : "+entry.time_from.slice(0, -3)+"-"+entry.time_to.slice(0, -3)
            entry.classes = labelColor
            entry.label = entry.class_type
            entry.url = ""
            entry.view_calendar_type = "club_class"
          });

          commit('SET_CLUB_CLASSES', response.data)
          resolve(response)
        })
        .catch((error) => { 
          commit('SET_CLUB_CLASSES', [])
          reject(error) 
        })
    })
  },
  fetchTeachersClasses({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/adminViewAllTeacherFreeSlots")
        .then((response) => {
          var teacherBookingData = [];
          if(response.data.teacher_bookings.length){
            response.data.teacher_bookings.forEach(function(entry) {
              entry.startDate = new Date(entry.date+" "+entry.time_from)
              entry.endDate = new Date(entry.date+" "+entry.time_to)

              entry.title = entry.user.name+" "+entry.user.last_name+" : "+entry.time_from.slice(0, -3)+"-"+entry.time_to.slice(0, -3)
              entry.classes = "event-primary"
              entry.label = entry.calendar_type
              entry.url = ""
              entry.view_calendar_type = "teacher_class"

              if(entry.status == "P" || entry.status == "B") teacherBookingData.push(entry)
            });
          }

          // commit('ADD_CLUB_CLASSES', response.data.teacher_bookings)

          var studentBookingData = [];

          if(response.data.student_bookings.length){
            response.data.student_bookings.forEach(function(entry) {
              entry.startDate = new Date(entry.date+" "+entry.time)
              entry.endDate = new Date(entry.date+" "+entry.end_time)

              entry.title = entry.users.name+" "+entry.users.last_name+" : "+entry.time.slice(0, -3)+"-"+entry.end_time.slice(0, -3)
              entry.classes = "calEventStudentBooking"
              entry.label = entry.module.calendar_type
              entry.url = ""
              entry.calendar_type = "teacher"
              entry.view_calendar_type = "student_class"

              if(entry.attendance != "Cancelled") studentBookingData.push(entry)
            });
          }
          
          var newArray = teacherBookingData.concat(studentBookingData)

          commit('ADD_CLUB_CLASSES', newArray)
          resolve(response)
        })
        .catch((error) => { 
          commit('ADD_CLUB_CLASSES', [])
          reject(error) 
        })
    })
  },
  cancelTeachersSlot({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/adminCancelTeachersSlot")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  searchStudents({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/teacher/logBook/viewClubStudents", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  bookStudentClubClasses({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/booking_2/admin/bookClass", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClubModules({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/viewClubTypeModules")
        .then((response) => {

          commit('SET_CLUB_MODULES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  },
  // fetchClubLocations({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/admin/viewClubCalenderLocation")
  //       .then((response) => {

  //         commit('SET_CLUB_LOCATIONS', response.data)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })

  // },
  fetchClubLocations({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewLocations")
        .then((response) => {

          commit('SET_CLUB_LOCATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createLocation({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createLocations", data)
        .then((response) => {

          commit('ADD_CLUB_LOCATION', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  setLocationTimes({ commit }, locationTimes) {
    return new Promise((resolve, reject) => {
      commit('SET_LOCATION_TIMES', locationTimes)
    })
  },

  createClubCalender({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createClubCalender", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error.response)  })
    })
  },

  updateClubCalender({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateAClubCalender", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error.response)  })
    })
  },
  cancelClubCalender({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteClubCalender", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error.response)  })
    })
  },
  cancelTeacherCalender({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/adminCancelTeachersSlot", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error.response)  })
    })
  },
  cancelMultipleTeacherCalender({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteAClubCalender", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error.response)  })
    })
  },

}
